import * as yup from 'yup';
import { Step } from '../../CharitableGiving.meta';

export const STEP_ID: Step = 'fundAccounts';

export interface FormValues {
  fundAccounts: string[];
}

export const validation = yup.object().shape({
  fundAccounts: yup
    .array()
    .of(yup.string())
    .min(1, 'You need to select at least one account to proceed.'),
});
